import React, { useContext } from 'react';
// import { Redirect, useHistory } from 'react-router-dom';
import { Row } from 'antd';
import { Button } from 'components';
import LoginImg from '../../assests/images/login-img.png';
import LoginImgTablet from '../../assests/images/login-img-tablet.png';
import LoginImgMobile from '../../assests/images/login-img-mobile.png';
import { DimensionsContext } from '../../context/dimensions.context';
import { uyeOlButtonClickEvent} from 'utils/fb-pixel-code-event';
import { useHistory} from 'react-router-dom';

const FastLogin = () => {
  let history = useHistory();
  const { isPc, isScreenLG, isPhone767, isScreen480991 } = useContext(DimensionsContext);


  return (
    <>
      <Row className="login-signup fast-login-row">
        <h3 className="section__title">Üye Ol</h3>
        <p className="info-text--big margin-bottom-spacing-m">
        Mesaj Üssü servisine Turkcell numaranız ile üye olun, firmanızı tanımlayın, mesaj göndermeye hemen başlayın.
        </p>
        <Button
          shape="round"
          type="ghost"
          className="signup-button"
          onClick={()=>{
            uyeOlButtonClickEvent();
            history.push("/SignUp");
          }}
        >
          Üye Ol
        </Button>
      </Row>
      <figure>
        { isScreen480991 ? <img className="a" src={LoginImgTablet} alt='Image' /> :
          isPhone767 ? <img className="b" src={LoginImgMobile} alt='Image' /> :
            <img className="c" src={LoginImg} alt='Image' />
        }
      </figure>
    </>
  );
};

export default FastLogin;
